<template>
  <div>
    <Banner type="product-inquiry" :style="{ height: '300px' }" />
    <div class="page-container j-container-box-shadow container">
      <span class="j-title title">{{ $t('product_inquiry.title') }}</span>

      <div class="form-container">
        <a-row :gutter="[60, 60]">
          <a-col :xs="24" :sm="24" :md="12">
            <a-form
              ref="form"
              :model="form"
              :label-col="labelCol"
              :wrapper-col="wrapperCol"
              :colon="false"
            >
              <a-form-item
                name="name"
                :label="$t('product_inquiry.contact_person')"
                labelAlign="left"
                :rules="[
                  {
                    type: 'string',
                    required: true,
                    message: $t('product_inquiry.contact_person_msg')
                  },
                  validateLength(30)
                ]"
              >
                <a-input v-model:value="form.name" />
              </a-form-item>

              <a-form-item
                :rules="{
                  type: 'number',
                  required: true
                }"
                name="gender"
                :label="$t('product_inquiry.gender')"
                labelAlign="left"
              >
                <a-radio-group v-model:value="form.gender">
                  <a-radio :style="radioStyle1" :value="0">
                    {{ $t('product_inquiry.gender_female') }}
                  </a-radio>
                  <a-radio :style="radioStyle2" :value="1">
                    {{ $t('product_inquiry.gender_male') }}
                  </a-radio>
                </a-radio-group>
              </a-form-item>

              <a-form-item
                :rules="{
                  type: 'string',
                  required: true,
                  message: $t('product_inquiry.country_region_msg')
                }"
                name="country"
                :label="$t('product_inquiry.country_region')"
                labelAlign="left"
              >
                <a-select show-search v-model:value="form.country">
                  <a-select-option
                    v-for="country in countryList"
                    :key="country.id"
                    :value="country.name"
                    >{{ $t(country.name) }}</a-select-option
                  >
                </a-select>
              </a-form-item>

              <a-form-item
                :rules="[
                  {
                    type: 'email',
                    required: true,
                    message: $t('product_inquiry.email_msg'),
                    trigger: 'blur'
                  },
                  validateLength(30)
                ]"
                name="email"
                :label="$t('product_inquiry.email')"
                labelAlign="left"
              >
                <a-input v-model:value="form.email" />
              </a-form-item>
              <!-- 
{
                    type: 'string',
                    required: true,
                    message: $t('product_inquiry.phone_msg')
                  }, -->
              <a-form-item
                :rules="[validateLength(30)]"
                name="phoneNum"
                :label="$t('product_inquiry.phone')"
                labelAlign="left"
              >
                <a-input v-model:value="form.phoneNum" />
              </a-form-item>

              <a-form-item
                :rules="[
                  {
                    type: 'string',
                    required: true,
                    message: $t('product_inquiry.company_msg')
                  },
                  validateLength(60)
                ]"
                name="companyName"
                :label="$t('product_inquiry.company')"
                labelAlign="left"
              >
                <a-input v-model:value="form.companyName" />
              </a-form-item>

              <a-form-item
                :rules="[
                  {
                    type: 'string',
                    required: true,
                    message: $t('product_inquiry.inquiry_msg')
                  },
                  validateLength(120)
                ]"
                name="question"
                :label="$t('product_inquiry.inquiry')"
                labelAlign="left"
              >
                <a-textarea v-model:value="form.question" :rows="4" />
              </a-form-item>

              <a-form-item
                :rules="[
                  {
                    type: 'string',
                    required: true,
                    message: $t('product_inquiry.captcha_msg')
                  },
                  validateLength(4)
                ]"
                name="captcha"
                :label="$t('product_inquiry.captcha')"
                labelAlign="left"
              >
                <div style="display: flex; align-items: center;">
                  <a-input style="flex: 1" v-model:value="form.captcha" />
                  <span class="get-captcha" @click="getValidateCode">
                    <img
                      height="32"
                      width="96"
                      v-if="validateImg"
                      :src="validateImg"
                      :alt="$t('product_inquiry.captcha')"
                    />
                  </span>
                </div>
              </a-form-item>
            </a-form>
          </a-col>

          <a-col :xs="24" :sm="24" :md="12">
            <div class="right-section">
              <a-table
                row-key="id"
                size="middle"
                :columns="columns"
                bordered
                :data-source="smGuestFeedbackVehicle"
                :pagination="false"
                :scroll="{ y: 447 }"
              >
                <template #footer>
                  <div class="table-footer">
                    <a @click="handleContinueInquiry">
                      <AddIcon class="icon" />
                      <span class="add-label">
                        {{ $t('product_inquiry.continue_sourcing') }}
                      </span>
                    </a>
                  </div>
                </template>

                <template #action="{ index }">
                  <DeleteIcon
                    @click="handleRemoveVehicle(index)"
                    class="icon"
                  />
                </template>

                <template #photo="{record}">
                  <img
                    alt="pic"
                    :src="getPreviewImg(record.showImg)"
                    v-if="getPreviewImg(record.showImg)"
                    width="120"
                    height="75"
                  />
                  <div v-else>
                    {{ $t('common.no_img') }}
                  </div>
                </template>

                <template #name="{record}">
                  <div>{{ $t(record.vehicleName) }}</div>
                  <div class="name-info">{{ $t(record.vehicleType) }}</div>
                </template>

                <template #quantity="{ record, index }">
                  <!-- <a-input type="number" v-model:value="record.quantity">
                    <template #addonBefore>
                      <MinusOutlined
                        class="btn-icon"
                        @click="record.quantity > 1 && record.quantity--"
                      />
                    </template>
                    <template #addonAfter>
                      <PlusOutlined
                        class="btn-icon"
                        @click="record.quantity++"
                      />
                    </template>
                  </a-input> -->
                  <QuantityInput
                    @quantity-change="
                      value => handleQuantityChange(value, record, index)
                    "
                    :quantity="record.quantity"
                  />
                </template>
              </a-table>
            </div>
          </a-col>
        </a-row>

        <div class="action">
          <a-button
            @click="handleInquiry"
            class="j-height-auto action-button"
            type="primary"
            :loading="loading"
          >
            {{ $t('product_inquiry.action') }}
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Banner from '@/components/banner/Banner.vue';
import AddIcon from '@/components/icons/AddIcon.vue';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import {
  getValidateCode,
  queryCountryList,
  addGuestFeedback
} from '@/api/apis';
// import { MinusOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { mapActions, mapState } from 'vuex';
import { baseFileUrl } from '@/utils/constants';
import { validateQuantity, validateLength } from '@/utils/validate';
import QuantityInput from '@/components/quantity-input/QuantityInput.vue';

export default defineComponent({
  name: 'ProductInquiry',
  components: {
    Banner,
    AddIcon,
    DeleteIcon,
    // MinusOutlined,
    // PlusOutlined
    QuantityInput
  },
  data() {
    return {
      validateQuantity,
      validateLength,
      loading: false,
      validateImg: null,
      form: {
        gender: 1,
        checkKey: 'key_' + (Math.floor(Math.random() * 10000) + 10000)
      },
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      radioStyle1: {
        display: 'inline-block',
        height: '30px',
        lineHeight: '30px',
        marginRight: '40px'
      },
      radioStyle2: {
        display: 'inline-block',
        height: '30px',
        lineHeight: '30px'
      },
      countryList: [],
      smGuestFeedbackVehicle: new Array<any>(),
      columns: [
        {
          title: this.$t('product_inquiry.pi_items'),
          dataIndex: 'item',
          width: 140,
          slots: { customRender: 'photo' }
        },
        {
          title: this.$t('product_inquiry.pi_name'),
          dataIndex: 'name',
          width: 140,
          slots: { customRender: 'name' }
        },
        {
          title: this.$t('product_inquiry.pi_quantity'),
          dataIndex: 'quantity',
          width: 120,
          slots: { customRender: 'quantity' }
        },
        {
          title: '',
          width: 60,
          align: 'center',
          slots: { customRender: 'action' }
        }
      ]
    };
  },
  computed: {
    ...mapState(['inquireFormData', 'previousUrl'])
  },
  created() {
    this.restoreCacheData();
    this.getValidateCode();
    this.getCountryList();
  },
  methods: {
    ...mapActions(['setInquireFormData', 'clearInquireFormData']),
    async restoreCacheData() {
      if (this.inquireFormData) {
        this.form = this.inquireFormData.form;
        this.smGuestFeedbackVehicle =
          this.inquireFormData.smGuestFeedbackVehicle || [];
      }
      if (
        this.$route.params.id &&
        this.smGuestFeedbackVehicle.every(i => i.id !== this.$route.params.id)
      ) {
        this.smGuestFeedbackVehicle.push({
          ...this.$route.params,
          quantity: 1
        });
        this.cacheFormData();
      }
    },
    async getValidateCode() {
      const res = await getValidateCode(this.form.checkKey);
      if (res.success) {
        this.validateImg = res.result;
      }
    },
    async getCountryList() {
      const res = await queryCountryList();
      if (res.success) {
        this.countryList = res.result;
      }
    },
    getPreviewImg(showImg) {
      const images: string[] = (showImg || '').split(',');
      return images.length && images[0] ? `${baseFileUrl}${images[0]}` : '';
    },
    cacheFormData() {
      this.setInquireFormData({
        form: this.form,
        smGuestFeedbackVehicle: this.smGuestFeedbackVehicle
      });
    },
    handleRemoveVehicle(index) {
      this.smGuestFeedbackVehicle.splice(index, 1);
      this.cacheFormData();
    },
    handleContinueInquiry() {
      this.cacheFormData();
      if (this.previousUrl === '/products') {
        this.$router.back();
      } else {
        this.$router.push('/products');
      }
    },
    handleQuantityChange(value, record, index) {
      this.smGuestFeedbackVehicle.splice(index, 1, {
        ...record,
        quantity: value
      });
      this.cacheFormData();

      // set cache
    },
    handleInquiry() {
      (this.$refs as any).form
        .validate()
        .then(async () => {
          this.loading = true;
          const res = await addGuestFeedback({
            ...this.form,
            smGuestFeedbackVehicle: this.smGuestFeedbackVehicle.map(i => ({
              inquireVehicleId: i.id,
              inquireVehicleName: i.vehicleName,
              inquireVehicleNumber: i.quantity,
              modelNum: i.modelNum
            }))
          });
          if (res.success) {
            message.success(this.$t(res.message));
            this.clearInquireFormData();
            this.form = {
              gender: 1,
              checkKey: 'key_' + (Math.floor(Math.random() * 10000) + 10000)
            };
            this.smGuestFeedbackVehicle = [];
            this.getValidateCode();
          }
          this.loading = false;
        })
        .catch();
    }
  }
});
</script>

<style lang="scss" scoped>
.container {
  padding: 0 80px;
  background-color: white;
  margin-top: -200px;

  .title {
    padding: 60px 0 30px 0;
    display: block;
  }

  .get-captcha {
    margin-left: 10px;
    cursor: pointer;
    width: 96px;
    text-align: right;
  }

  .right-section {
    display: flex;
    flex-direction: column;
    height: 100%;

    padding: 4px 0;

    .name-info {
      color: #999999;
      font-size: 12px;
      line-height: 19px;
    }

    .icon {
      cursor: pointer;
    }

    .table-footer {
      color: $primary-color;
      display: flex;
      align-items: center;
      justify-content: center;

      .add-label {
        margin-left: 10px;
      }

      &:hover {
        color: $primary-hover-color;
      }
    }
  }

  .action {
    text-align: center;
    padding: 36px 0 60px 0;

    .action-button {
      padding: 10px 42px;
    }
  }
}

textarea {
  resize: none;
}

::v-deep(.ant-table) {
  border: 1px solid $secondary-color2;
}

::v-deep(.ant-table.ant-table-bordered .ant-table-footer) {
  background: white;
  padding: 12px;
  border: none;
  &::before {
    background: $secondary-color2;
  }
}

::v-deep(.ant-table-bordered .ant-table-body > table) {
  border: none;
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid $secondary-color2;
  }

  .ant-table-tbody > tr > td {
    border-right: none;
  }

  .ant-table-tbody > tr:nth-child(even) {
    background: white;
  }
}

::v-deep(.ant-table.ant-table-middle
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-header
    > table) {
  .ant-table-thead > tr > th:first-child {
    padding: 10px 40px;
  }
}

::v-deep(.ant-table.ant-table-middle
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-body
    > table) {
  .ant-table-tbody > tr > td:first-child {
    padding: 20px 40px;
  }
}
</style>
